import React from 'react';
import { useForm } from 'react-hook-form';
import { Button, Input, Toaster } from '../common';
import { useAuth } from '../../contexts/AuthContext';
import { useUpdateProfile } from '../../hooks/useProfile';
import toast from 'react-hot-toast';
import { FloppyDisk } from 'iconoir-react';

interface PersonalInformationFormData {
  firstName: string;
  lastName: string;
  email: string;
}

const ProfileSettingsForm = () => {
  const { user, checkStatus } = useAuth();
  const { mutateAsync: updateProfile, isPending } = useUpdateProfile();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<PersonalInformationFormData>({
    defaultValues: {
      firstName: user?.first_name,
      lastName: user?.last_name,
      email: user?.email,
    },
  });

  const onSubmit = async (data: PersonalInformationFormData) => {
    const payload = {
      first_name: data.firstName.trim(),
      last_name: data.lastName.trim(),
    };

    // Update profile mutation
    await updateProfile(payload, {
      onSuccess: () => {
        toast.custom(t => (
          <Toaster
            message='Profile has been updated successfully'
            type='success'
            id={t.id}
          />
        ));
      },
      onError: error => {
        toast.custom(t => (
          <Toaster
            message={error?.message || 'Failed to update profile'}
            type='error'
            id={t.id}
          />
        ));
      },
      onSettled: async () => {
        await checkStatus();
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h5 className='text-heading-500 !font-medium mb-6'>Basic Information</h5>
      <div className='grid grid-cols-2 gap-4 mb-6'>
        <Input
          label='First Name'
          {...register('firstName', {
            required: 'First name is required',
          })}
          helperText={errors.firstName?.message as string}
          color={errors.firstName ? 'error' : 'default'}
        />
        <Input
          label='Last Name'
          {...register('lastName', {
            required: 'Last name is required',
          })}
          helperText={errors.lastName?.message as string}
          color={errors.lastName ? 'error' : 'default'}
        />
        <Input
          wrapperClassName='col-span-2 mt-2'
          label='Email'
          {...register('email', {
            required: 'Email is required',
          })}
          disabled={true}
        />
      </div>
      <div className='flex justify-end'>
        <Button
          className='px-[2.9688rem]'
          color='dark'
          type='submit'
          isLoading={isPending}
        >
          <FloppyDisk className='w-6 h-6' />
          Save
        </Button>
      </div>
    </form>
  );
};

export default ProfileSettingsForm;
